import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Switch, useLocation } from 'react-router-dom';
import Login from '../Login';
import PrivateRoute from './CustomRoutes/PrivateRoute';
import PublicRoute from './CustomRoutes/PublicRoute';
import PublicTransaction from 'containers/PublicTransaction';
import GitHubCallback from 'containers/Hosting/GitHubCallback';
import { Route } from 'react-router-dom';

import resolveLayout from 'routes/layouts/resolveLayout';
import Chatbot from 'components/Chatbot';

// Component to conditionally render Chatbot based on current route
const ConditionalChatbot = () => {
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  
  // Define pages where chatbot should be visible
  const allowedPaths = [
    '/',                    // Home/Landing page
    '/jobsqueue',           // JobsQueue page
    '/testdata/products',   // TestData - Products
    '/testdata/buysell',    // TestData - Orders/BuySell
    '/testdata/new_buying_experience', // TestData - New Buying Experience
    '/testdata/simulation', // TestData - Simulation
    '/testdata/data_store', // TestData - Data Store
    '/testdata/accounts_contacts', // TestData - Accounts & Contacts
  ];
  
  // Check if current path matches any allowed path
  const isChatbotVisible = isLoggedIn && allowedPaths.some(path => 
    location.pathname === path
  );
  
  return isChatbotVisible ? <Chatbot /> : null;
};

const App = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <BrowserRouter>
      <Switch>
        {!isLoggedIn ? (
          <Route
            key={'transaction'}
            path={'/view/:service/:executionid'}
            component={PublicTransaction}
            exact={true}
          />
        ) : null}
        <PublicRoute exact path="/auth" component={Login} />
        <PrivateRoute exact path="/auth/github/callback" component={GitHubCallback} />
        <PrivateRoute path="/" component={resolveLayout} />
      </Switch>
      {/* Conditional Chatbot - Only visible on specific pages when logged in */}
      <ConditionalChatbot />
    </BrowserRouter>
  );
};

export default App;
